import { render, staticRenderFns } from "./VuebaseLayout.vue?vue&type=template&id=2ea3f5da"
import script from "./VuebaseLayout.vue?vue&type=script&lang=js"
export * from "./VuebaseLayout.vue?vue&type=script&lang=js"
import style0 from "./VuebaseLayout.vue?vue&type=style&index=0&id=2ea3f5da&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports